/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedFollowSearchProvider_user = {
    readonly favorites: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly serviceId: string | null;
            } | null;
        } | null> | null;
        readonly " $fragmentRefs": FragmentRefs<"FollowButton_favoritesConnection">;
    } | null;
    readonly " $refType": "SbSharedFollowSearchProvider_user";
};
export type SbSharedFollowSearchProvider_user$data = SbSharedFollowSearchProvider_user;
export type SbSharedFollowSearchProvider_user$key = {
    readonly " $data"?: SbSharedFollowSearchProvider_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedFollowSearchProvider_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedFollowSearchProvider_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "followSearchTypes",
      "type": "[types]"
    },
    {
      "kind": "RootArgument",
      "name": "followSearchPages",
      "type": "[String]"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "favorites",
      "storageKey": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        },
        {
          "kind": "Variable",
          "name": "pages",
          "variableName": "followSearchPages"
        },
        {
          "kind": "Variable",
          "name": "types",
          "variableName": "followSearchTypes"
        }
      ],
      "concreteType": "favoritesConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "favoritesEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Favorite",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "serviceId",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "FollowButton_favoritesConnection",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = 'd0deac136e73df1a3da13c1497127d43';
export default node;
